module.exports = __webpack_public_path__ + "static/media/Recruitment2019.271195eb.jpeg";